/**
 * Product Tabs – Tab-Wechsel für Produktbeschreibung (Beschreibung, Technische Daten, Downloads, Hersteller)
 * + Smooth-Scroll von „Alle Produktdetails anzeigen“ zur Tab-Sektion
 */
document.addEventListener('DOMContentLoaded', function () {
  // Smooth-Scroll zu Tab-Sektion bei Klick auf „Alle Produktdetails anzeigen“ – nur nach unten scrollen
  document.querySelectorAll('a[href="#product-tabs-section"], a[data-smooth-scroll-to-tabs]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('product-tabs-section');
      if (target) {
        e.preventDefault();
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (targetTop > currentScroll) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  document.querySelectorAll('.product-tabs').forEach(function (container) {
    var tabs = container.querySelectorAll('.product-tabs__tab');
    var panels = container.querySelectorAll('.product-tabs__panel');
    var titleEl = container.querySelector('[data-tab-title]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabId = tab.dataset.tab;
        if (!tabId) return;

        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          t.classList.toggle('product-tabs__tab--active', t === tab);
        });

        panels.forEach(function (panel) {
          var isActive = panel.dataset.tabPanel === tabId;
          panel.classList.toggle('product-tabs__panel--active', isActive);
          panel.hidden = !isActive;
        });

        if (titleEl) {
          titleEl.textContent = tab.textContent.trim();
        }
      });
    });

    // Technische Daten: Als Text gespeichertes HTML (z. B. <table>) als echte Tabelle rendern
    var technischeDatenPanel = container.querySelector('.product-tabs__panel[data-tab-panel="technische_daten"]');
    if (technischeDatenPanel) {
      var raw = (technischeDatenPanel.textContent || '').trim();
      if (raw.indexOf('<table') === 0 || raw.indexOf('<TABLE') === 0) {
        technischeDatenPanel.innerHTML = raw;
      }
    }
  });
});
